module.exports = __webpack_public_path__ + "static/media/clean-code.895348eb.jpg";